export default __webpack_public_path__ + "static/media/4b_Haley Traub.acd485d0.png";